import React from 'react'

import { useNavigate } from 'react-router-dom'

import { Col, Row, Typography, PageHeader, Tabs } from 'antd'

import { AgentsReports, BranchReports } from './ReportsComponent'

const { Title } = Typography

function IReport () {

    const navigate = useNavigate()

    const branchcode = localStorage.getItem('brCode')
    const branchName = localStorage.getItem('brName')
    const brBusinessType = localStorage.getItem('brBusinessType')

    return(
        <div className='dashboard'>
            <Row className='main-heading'>

                <Col md={24}>
                    <PageHeader
                        className="site-page-header-reports"
                        onBack={() => navigate(-1)}
                        title={
                            <Title level={2}> { branchName } <span className='font-red'> ( { brBusinessType } ) </span> </Title>
                        }
                    />
                </Col>

                <Col md={24}>
                    <Tabs defaultActiveKey="1" type="card">
                        <Tabs.TabPane tab="Branch Reports" key="1">
                            <BranchReports branchCode={branchcode} />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Agents Reports" key="2">
                            <AgentsReports />
                        </Tabs.TabPane>
                    </Tabs>
                </Col>
            </Row>
        </div>
    )
}

export default IReport